import React from 'react'
import { CFView, CFIcon } from 'components'

export default props => (
  <CFView {...props}>
    <CFIcon icon="arrow-left" fontSize={28} />
  </CFView>
)
